import { render } from "./TyGiaCompoment.vue?vue&type=template&id=3ecd42b4"
import script from "./TyGiaCompoment.vue?vue&type=script&lang=js"
export * from "./TyGiaCompoment.vue?vue&type=script&lang=js"

import "./TyGiaCompoment.vue?vue&type=style&index=0&id=3ecd42b4&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__